export function parseInteger(val: string) {
    return parseInt(val, 10)
}
